<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
    >
        <path
            d="M10 2C5.589 2 2 5.589 2 10C2 14.411 5.589 18 10 18C14.411 18 18 14.411 18 10C18 5.589 14.411 2 10 2ZM13.457 9.957L10.707 12.707C10.512 12.902 10.256 13 10 13C9.744 13 9.488 12.902 9.293 12.707L6.543 9.957C6.152 9.566 6.152 8.934 6.543 8.543C6.934 8.152 7.566 8.152 7.957 8.543L10 10.586L12.043 8.543C12.434 8.152 13.066 8.152 13.457 8.543C13.848 8.934 13.848 9.566 13.457 9.957Z"
            fill="currentColor"
        />
    </svg>
</template>
